import Header from "./components/Header";
import Hero from "./components/Hero";
import ArchiveLibrary from "./components/ArchiveLibrary";
import Timeline from "./components/Timeline";
import Collections from "./components/Collections";
import DeepRead from "./components/DeepRead";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <ArchiveLibrary />
        <Timeline />
        <Collections />
        <DeepRead />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}